export default function Header() {
  const header = document.querySelector(".site-header");
  const nav = document.querySelector("#site-navigation");
  const pickUpLink = nav.querySelector("li.locator a");
  const storeLocatorLink = document.querySelector("#footer-menu li:first-child a");

  // sticky
  window.addEventListener("scroll", () => {
    if (window.scrollY > 5) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });

  // mobile
  if (window.innerWidth < 900) {
    const burger = document.querySelector("#hamburger");
    const navLinks = nav.querySelectorAll("li.menu-item a");

    burger.addEventListener("click", () => {
      nav.classList.toggle("open");
      burger.classList.toggle("expanded");
    })

    navLinks.forEach((link) => {
      link.addEventListener("click", () => {
        nav.classList.remove("open");
        burger.classList.remove("expanded");
      })
    })
  }

  function trackLocatorClick(e, location) {
    e.preventDefault();

    function callBack() {
      window.location = "/store-locator";
    }

    gtag('event', 'Store Locator Clicked', {
      'event_callback': callBack,
      'page_location': location
    });
  }

  if (pickUpLink) {
    pickUpLink.addEventListener("click", (e) => {
      trackLocatorClick(e, "Header");    
    })
  }

  storeLocatorLink.addEventListener("click", (e) => {
    trackLocatorClick(e, "Footer");
  })
}
